module.exports = __webpack_public_path__ + "img/unisociesc.5af97c39.svg";